<template>
  <div class="stil-kartice stil-kartice-hitrih-dostopov" v-if="showLinks">
    <div class="odmik-v-kartici">
      <div>
        <p class="open-sans-20pt">
          Hiter dostop
        </p>
      </div>
      <div>
        <div class="bliznjice">
          <div v-for="link in links">
            <template v-if="showLink(link)">
              <div class="posamezen-dostop">
                <a v-bind:href="link.path">
                  <el-button class="stil-bliznjic" :class="link.stil">
                    <span>
                      <img :src="link.src" class="icons">
                    </span>
                    <span>
                      <span class="primarna-barva" :class="link.barva">
                       {{ link.name }}
                      </span>
                    </span>
                  </el-button>
                </a>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {Button} from 'element-ui'

  export default {
    name: 'KarticaHitriDostop',
    props: {
      seznamPaketov: Array,
      podatkiStranke: null
    },
    data () {
      return {
        showLinks: true,
        links: [
          {
            path: '/Nastavitve/NastavitveMreznaOprema',
            isLoaded: false,
            src: '/static/img/Domov/icon_awesome_wifi.png',
            name: 'INTERNET NASTAVITVE',
            fix: true,
            ott: false,
            prepaid: false,
            umts: false
          },
          {
            path: '/Nastavitve/NastavitveTelefonija',
            isLoaded: false,
            src: '/static/img/Domov/icon-awesome-phone-alt.png',
            name: 'NASTAVITVE TELEFONIJE',
            fix: true,
            ott: false,
            prepaid: false,
            umts: true
          },
          {
            path: '/Nastavitve/NastavitveElektronskaPosta',
            isLoaded: false,
            src: '/static/img/Domov/icon-material-email.png',
            name: 'NASTAVITVE E-MAIL',
            fix: true,
            ott: false,
            prepaid: false,
            umts: false
          },
          {
            path: '/Naroci/NarociTelevizija',
            isLoaded: false,
            src: '/static/img/Domov/icon-awesome-tv.png',
            name: 'TV PAKETI',
            fix: false,
            ott: true,
            prepaid: false,
            umts: false
          },
          {
            path: '/MojT2/Eposlovanje',
            isLoaded: false,
            src: '/static/img/Domov/icon-ionic-md-settings.png',
            name: 'UREJANJE ePOSLOVANJA',
            fix: false,
            ott: true,
            prepaid: true,
            umts: true
          },
          {
            path: 'https://tv2go.t-2.net/',
            isLoaded: true,
            src: '/static/img/dashboard/Icon-material-live-tv-white.png',
            name: 'OGLED TV2GO',
            stil: 'gumb-potrdi stil-gumba-tv-go',
            barva: 'bela-pisava',
            fix: true,
            ott: true,
            prepaid: true,
            umts: false
          },
          {
            path: 'https://tv.t-2.net/',
            isLoaded: true,
            src: '/static/img/dashboard/Icon-material-live-tv-white.png',
            name: 'T-2 TV',
            stil: 'gumb-potrdi stil-gumba-tv-go',
            barva: 'bela-pisava',
            fix: false,
            ott: true,
            prepaid: true,
            umts: false
          }
        ]
      }
    },
    components: {
      [Button.name]: Button
    },
    methods: {
      showLink (gumb) {
        if (gumb.fix && this.podatkiStranke.obstajaFixPrikljucek === '1') return true
        else if (gumb.ott && this.podatkiStranke.obstajaOttPrikljucek === '1') return true
        else if (gumb.prepaid && this.HasPermission('PREPAID_NAROCNINE')) return true
        else if (gumb.umts && this.podatkiStranke.obstajaUmtsPrikljucek === '1') return true
        else return false
      }
    },
    watch: {
      links (updatedLinkList) {
        for (let i = 0; i < updatedLinkList.length; i++) {
          if (updatedLinkList.isLoaded) {
            this.showLinks = true
            return
          }
        }
      }
    }
  }
</script>
<style scoped src="../../../../static/css/Domov/naslovna-stran.css">
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/NaslovnaStran/KarticaHitriDostop.vue